export const commonErrorMessages = {
	AUTH_ERROR: 'No token passed and no token could be found in localstorage. Please login and / or pass a valid token',
	TYPE_ERROR: 'Failed to fetch',
	SRV_ERR_PBX_LOGIN : 'pbxLogin error - login timeout',
	SRV_ERR_INV_PW: 'pbxLogin error- INVALID PASSWORD',
	UNSUPP_TYPE_MSG: 'Unsupported Media Type',
};

export const accountMessages = {
	CREATE_ACCOUNT: 'account.CREATE_ACCOUNT',
	UPDATE_ACCOUNT: 'account.UPDATE_ACCOUNT',
	ERR_CREATE_ACCOUNT: 'account.ERR_CREATE_ACCOUNT',
	ERR_CREATE_ADMIN: 'account.ERR_CREATE_ADMIN',
	ERR_UPDATE_ACCOUNT: 'account.ERR_UPDATE_ACCOUNT',
	ERR_UPDATE_ACOUNT: 'account.ERR_UPDATE_ACCOUNT'
};

export const contactMessages = {
	ERR_CREATE_CONTACT: 'account.ERR_CREATE_CONTACT',
	ERR_DELETING_CONTACT: 'account.ERR_DELETE_CONTACT',
	INVALID_EMAIL_ADDRESS: 'InvalidEmailAddress',
	CONTACT_NOT_FOUND: 'ContactNotFound'
};

export const commonMessages = {
	ACC_NOT_FOUND: 'common.messages.ACC_NOT_FOUND',
	NOT_VALID_EMAIL: 'common.messages.NOT_VALID_EMAIL',
	ENTER_ACC: 'common.messages.ENTER_ACC',
	CHECK_FIELDS: 'common.messages.CHECK_FIELDS',
	CHECK_DEVICE: 'common.messages.CHECK_DEVICE',
	ERROR_DEFAULT: 'common.messages.ERROR_DEFAULT',
	ERR_PROGRESS: 'common.messages.ERR_PROGRESS',
	LOADING: 'app.loading',
	NO_IP: 'common.messages.NO_IP',
	TUNNEL_AUTH_ERR: 'common.messages.TUNNEL_AUTH_ERR',
	UNKNOWN_STATUS: 'common.messages.UNKNOWN_STATUS',
	READONLY_STATUS_UNAVAILABLE: 'common.messages.READONLY_STATUS_UNAVAILABLE'
};

export const commonErrorNames = {
	MULTI_MATCH: 'MultipleMatching',
	ACC_NOT_FOUND: 'AccountNotFound',
	USER_NOT_FOUND: 'UserNotFound',
	INVALID_EMAIL: 'InvalidEmail',
	USER_EXISTS: 'UserAlreadyExists',
	MOBILE_EXISTS: 'MobileAlreadyExists'
};

export const gatewayMessages = {
	NO_GATEWAY: 'gwpIntegration.status.NO_GATEWAY',
	ADD_GATEWAY: 'gwpIntegration.status.ADD_GATEWAY',
	CONTINUE: 'gwpIntegration.status.CONTINUE',
	ADD_PBX: 'gwpIntegration.status.ADD_PBX',
	CONNECT_PBX: 'gwpIntegration.status.CONNECT_PBX',
	SYNC_PBX: 'gwpIntegration.status.SYNC_PBX',
	DEPLOYMENT: 'gwpIntegration.status.DEPLOYMENT',
	OVERVIEW: 'gwpIntegration.status.OVERVIEW',
	CONFIGURE_GATEWAY: 'gwpIntegration.status.CONFIGURE_GATEWAY',
	FINISH_CUSTOMER: 'gwpIntegration.status.FINISH_CUSTOMER'
};

export const gatewayErrorMessages = {
	ERR_TUNN: 'site.ERR_TUNN',
	ERR_GATEWAY: 'site.ERR_GATEWAY',
	ERR_SITE: 'site.ERR_SITE',
	ERR_UPDATE_SITE: 'site.ERR_UPDATE_SITE',
	INVALID_VCC_DID_NUMBER: 'site.INVALID_VCC_DID_NUMBER',
	ERR_CREATE_SITE: 'site.ERR_CREATE_SITE',
	ERR_CLIENT: 'site.ERR_CLIENT',
	ERR_GET_NETWORK: 'site.ERR_GET_NETWORK',
	ERR_SET_NETWORK: 'site.ERR_SET_NETWORK',
	ERR_SET_NETWORK_TIMEOUT: 'site.ERR_SET_NETWORK_TIMEOUT',

	ERR_CREATE_PBX: 'pbx.ERR_CREATE_PBX',
	ERR_UPDATE_PBX: 'pbx.ERR_UPDATE_PBX',
	ERR_UPDATE_PBX_SERVER: 'pbx.ERR_UPDATE_PBX_SERVER',
	ERR_UPDATE_PBX_TIMEOUT: 'pbx.ERR_UPDATE_PBX_TIMEOUT',
	ERR_SIP_TRUNK_CONFIG: 'pbx.ERR_SIP_TRUNK_CONFIG',
	ERR_SIP_TRUNK_CONFIG_TOAST: 'pbx.ERR_SIP_TRUNK_CONFIG_TOAST',
	ERR_NO_TRUNKS: 'pbx.ERR_NO_TRUNKS',
	PBX_TRUNK_NOT_REGISTER: 'pbx.PBX_TRUNK_NOT_REGISTER',
	ERR_TRUNK_LICENSE: 'pbx.ERR_TRUNK_LICENSE',
	CANNOT_CONNECT_PBX: 'pbx.CANNOT_CONNECT_PBX',
	SYSTEM_DATA_TIMEOUT: 'pbx.SYSTEM_DATA_TIMEOUT',
	ERR_GET_PBX: 'pbx.ERR_GET_PBX',
	ERR_CONNECT_MEDIA: 'pbx.ERR_CONNECT_MEDIA',

	ERROR_SYNC_PBX: 'connect.ERROR_SYNC',
	INV_PSWD: 'connect.INV_PSWD',
	NO_CONNECTION: 'connect.NO_CONNECTION',
	CONNECT_PBX: 'connect.CONNECT_PBX',
	ERROR_RESYNC: 'connect.ERROR_RESYNC',
	ERR_SYNC_SCHEDULE: 'connect.ERR_SYNC_SCHEDULE',

	ERROR_SYNC: 'resync.ERROR_SYNC',

	ERR_GET_GROUPS: 'officelink.ERR_GET_GROUPS',
	ERR_UPDATE_KEY_LINE: 'officelink.ERR_UPDATE_KEY_LINE',
	ERR_SEND_EMAIL: 'officelink.ERR_SEND_EMAIL',
	ERR_RETRIEVE_USERS: 'officelink.ERR_RETRIEVE_USERS',
	ERR_RETRIEVE_GROUPS: 'officelink.ERR_RETRIEVE_GROUPS',

	ERROR_ADVANCED: 'advanced.ERROR_ADVANCED',
	SEND_PROBLEM: 'advanced.SEND_PROBLEM',
	ERR_SEND_TRACE: 'advanced.ERR_SEND_TRACE',
	ERR_COLLECT_LOGS: 'advanced.ERR_COLLECT_LOGS',
	ERR_LOG_TIMEOUT: 'advanced.ERR_LOG_TIMEOUT',
	ERR_UPLOAD_LOGS: 'advanced.ERR_UPLOAD_LOGS',
	ERR_UPLOAD_TIMEOUT: 'advanced.ERR_UPLOAD_TIMEOUT',

	LOST_GATEWAY_CONNECTION: 'gatewayConnect.messages.LOST_GATEWAY_CONNECTION',
	LOST_OAI_CONNECTION: 'gatewayConnect.messages.LOST_OAI_CONNECTION',
	NOT_START_PBX_CONNECTION: 'gatewayConnect.messages.NOT_START_PBX_CONNECTION',
	INVALID_TRUSTED_APP_PASSWORD: 'gatewayConnect.messages.INVALID_TRUSTED_APP_PASSWORD',
	INVALID_IP: 'gatewayConnect.messages.INVALID_IP',
	INVALID_GATEWAY_IP: 'gatewayConnect.messages.INVALID_GATEWAY_IP',
	INVALID_PBX_IP: 'gatewayConnect.messages.INVALID_PBX_IP',
	TRUSTED_APP_DISABLED: 'gatewayConnect.messages.TRUSTED_APP_DISABLED',
	INVALID_TRUNK_GROUP: 'gatewayConnect.messages.INVALID_TRUNK_GROUP',
	LOST_CSTA_CONNECTION: 'gatewayConnect.messages.LOST_CSTA_CONNECTION',
	LOST_TRUNK_CONNECTION_PBX: 'gatewayConnect.messages.LOST_TRUNK_CONNECTION_PBX',
	LOST_TRUNK_CONNECTION_CLOUD: 'gatewayConnect.messages.LOST_TRUNK_CONNECTION_CLOUD',
	SYSTEM_UPDATE_AVAILABLE: 'gatewayConnect.messages.SYSTEM_UPDATE_AVAILABLE',
	CHECKING_CONNECT: 'gatewayConnect.messages.CHECKING_CONNECT',
	ERR_CONNECT_NEW_GATEWAY: 'gatewayConnect.messages.ERR_CONNECT_NEW_GATEWAY',
	FAILED_REGISTER_PBX_MEDIA: 'gatewayConnect.messages.FAILED_REGISTER_PBX_MEDIA',
	FAILED_REGISTER_MEDIA: 'gatewayConnect.messages.FAILED_REGISTER_MEDIA',
	FAILED_REGISTER_PBX: 'gatewayConnect.messages.FAILED_REGISTER_PBX',
	CSTA_NOT_ENABLED: 'gatewayConnect.messages.CSTA_NOT_ENABLED',
	FAILED_IP: 'gatewayConnect.messages.FAILED_IP',

	TUNNEL_AUTH_ERR: 'common.messages.TUNNEL_AUTH_ERR',
	ERR_PBX_LOGIN: 'common.messages.ERR_PBX_LOGIN',
	ERR_CONNECTION: 'common.messages.ERR_CONNECTION',
	ERR_PBX_INV_PW: 'common.messages.ERR_PBX_INV_PW',
	ERR_DATA_RESET: 'common.messages.ERR_DATA_RESET',
	ERR_SERVER_UNAVAILABLE: 'serverUnavailableModal.title',
	ERR_SERVICE_UNAVAILABLE_RETRY: 'common.messages.ERR_SERVICE_UNAVAILABLE_RETRY',
	ERR_SERVICE_UNAVAILABLE: 'common.messages.ERR_SERVICE_UNAVAILABLE',
	LOST_CTSA_CONNECTION: 'common.messages.LOST_CTSA_CONNECTION'
};

export const PBXTypes = {
	mivo250: 'integrations.gateway.pbxTypes.mivo250',
	mivo400: 'integrations.gateway.pbxTypes.mivo400',
	mivb: 'integrations.gateway.pbxTypes.mivb',
	mivconnect: 'integrations.gateway.pbxTypes.mivconnect',
	micflex: 'integrations.gateway.pbxTypes.micflex',
	mivo5000: 'integrations.gateway.pbxTypes.mivo5000',
	mivomxone: 'integrations.gateway.pbxTypes.mivomxone'
}

export enum UserRoles {
	USER = 'USER',
	TECHNICAL_SUPPORT = 'TECHNICAL_SUPPORT',
	ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
	PARTNER_ADMIN = 'PARTNER_ADMIN',
	GLOBAL_ADMIN = 'GLOBAL_ADMIN',
}


export const HidePartOfAccountForm = true;

export const productLicenses = {
	"MiTeam Meetings":  "MiTeam_Meetings"
};

export const ProductLicenseBundleName = {
	STANDALONE: 'standalone',
	OTHER: 'other',
	MIVB: 'mivb',
	MITELONE: 'mitelOne'
}

export const componentType = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary'
}

export const mitelOneLicenses = ["MitelOne_Basic","MitelOne_Essential", "MitelOne_Premier",	"MitelOne_Elite"];

export const mivoice5000Licenses = ["MiVoice5000_Premier", "MiVoice5000_Elite"];

export const mivoiceBusinessLicenses = ["MiVB_Entry", "MiVB_Premier", "MiVB_Elite"];

export const unifyPhoneCodes = {
  USER_PRODUCT: 'UnifyPhone',
  USER_PRODUCT_NAME: 'Unify Phone'
}

export const zappaPhoneCodes = {
  USER_PRODUCT: 'ZoomPSI',
  USER_PRODUCT_NAME: 'Zoom PSI'
}

export enum PolicyEffects {
    'ExplicitAllow',
    'ExplicitDeny',
    'ImplicitAllow',
    'ImplicitDeny'
};

export enum NotifyAlertType {
	DANGER = 'alert-danger',
	WARNING = 'alert-warning',
	SUCCESS = 'alert-success',
	INFO = 'alert-info'
};

export const pbxStatus = {
	UNKNOWN: 'unknown',
	UP: 'up',
	DOWN: 'down'
};

export const gatewayConnectStateMessages = {
	LOST_GATEWAY_CONNECTION: 'gatewayConnect.messages.LOST_GATEWAY_CONNECTION',
	LOST_OAI_CONNECTION: 'gatewayConnect.messages.LOST_OAI_CONNECTION',
	NOT_START_PBX_CONNECTION: 'gatewayConnect.messages.NOT_START_PBX_CONNECTION',
	INVALID_TRUSTED_APP_PASSWORD: 'gatewayConnect.messages.INVALID_TRUSTED_APP_PASSWORD',
	INVALID_IP: 'gatewayConnect.messages.INVALID_IP',
	INVALID_GATEWAY_IP: 'gatewayConnect.messages.INVALID_GATEWAY_IP',
	INVALID_PBX_IP: 'gatewayConnect.messages.INVALID_PBX_IP',
	TRUSTED_APP_DISABLED: 'gatewayConnect.messages.TRUSTED_APP_DISABLED',
	INVALID_TRUNK_GROUP: 'gatewayConnect.messages.INVALID_TRUNK_GROUP',
	LOST_CSTA_CONNECTION: 'gatewayConnect.messages.LOST_CSTA_CONNECTION',
	LOST_TRUNK_CONNECTION_PBX: 'gatewayConnect.messages.LOST_TRUNK_CONNECTION_PBX',
	LOST_TRUNK_CONNECTION_CLOUD: 'gatewayConnect.messages.LOST_TRUNK_CONNECTION_CLOUD',
	CANNOT_CONNECT_PBX: 'gatewayConnect.messages.CANNOT_CONNECT_PBX',
	SYSTEM_UPDATE_AVAILABLE: 'gatewayConnect.messages.SYSTEM_UPDATE_AVAILABLE',
	CHECKING_CONNECT: 'gatewayConnect.messages.CHECKING_CONNECT',
	ERR_CONNECT_NEW_GATEWAY: 'gatewayConnect.messages.ERR_CONNECT_NEW_GATEWAY',
	FAILED_REGISTER_PBX_MEDIA: 'gatewayConnect.messages.FAILED_REGISTER_PBX_MEDIA',
	FAILED_REGISTER_MEDIA: 'gatewayConnect.messages.FAILED_REGISTER_MEDIA',
	FAILED_REGISTER_PBX: 'gatewayConnect.messages.FAILED_REGISTER_PBX'
};

export const pbxTypes = {
	MIVO250: 'mivo250',
	MIVO400: 'mvo400',
	MIVB: 'mivb',
	MIVC: 'mivconnect'
};

export const pbxConnectError = {
	INVALID_TRUSTED_APP_PASSWORD: 'INVALID_TRUSTED_APP_PASSWORD',
	INVALID_IP: 'INVALID_IP',
	INVALID_GATEWAY_IP: 'INVALID_GATEWAY_IP',
	INVALID_PBX_IP: 'INVALID_PBX_IP',
	TRUSTED_APP_DISABLED: 'TRUSTED_APP_DISABLED',
	INVALID_TRUNK_GROUP: 'INVALID_TRUNK_GROUP',
};

export const pbxMessages = {
	CREATE_PBX: 'pbx.CREATE_PBX',
	UPDATE_PBX: 'pbx.UPDATE_PBX',
	ERR_CREATE_PBX: 'pbx.ERR_CREATE_PBX',
	ERR_UPDATE_PBX: 'pbx.ERR_UPDATE_PBX',
	ERR_UPDATE_PBX_SERVER: 'pbx.ERR_UPDATE_PBX_SERVER',
	ERR_UPDATE_PBX_TIMEOUT: 'pbx.ERR_UPDATE_PBX_TIMEOUT',
	ERR_SIP_TRUNK_CONFIG: 'pbx.ERR_SIP_TRUNK_CONFIG',
	ERR_SIP_TRUNK_CONFIG_TOAST: 'pbx.ERR_SIP_TRUNK_CONFIG_TOAST',
	ERR_NO_TRUNKS: 'pbx.ERR_NO_TRUNKS',
	PBX_TRUNK_NOT_REGISTER: 'pbx.PBX_TRUNK_NOT_REGISTER',
	ERR_TRUNK_LICENSE: 'pbx.ERR_TRUNK_LICENSE',
	CONFIG_PBX: 'pbx.CONFIG_PBX',
	CONFIG_FREESWITCH: 'pbx.CONFIG_FREESWITCH',
	WAIT_FREESWTICH: 'pbx.WAIT_FREESWTICH',
	CANNOT_CONNECT_PBX: 'pbx.CANNOT_CONNECT_PBX',
	SYSTEM_DATA_TIMEOUT: 'pbx.SYSTEM_DATA_TIMEOUT',
	ERR_GET_PBX: 'pbx.ERR_GET_PBX',
	ERR_CONNECT_MEDIA: 'pbx.ERR_CONNECT_MEDIA',
  ERR_SERVER_UNAVAILABLE: 'serverUnavailableModal.title',
  GET_PBXLINKS: 'pbx.GET_PBXLINKS',
  MISSING_PBX_LINK: 'pbx.MISSING_PBX_LINK'
};


export enum FormAlertType {
	ERROR = 'alert-danger',
	SUCCESS = 'alert-success',
	WARNING = 'alert-warning'
};


export const productCodes = {
	GATEWAY: 'Gateway',
	MITELONE: 'MitelOne',
	MI_TEAM_MEETINGS: 'MiTeam Meetings',
	MIVOICE_BUSINESS:'MiVoice Business',
	MiVB_INTEGRATION: 'MiVB',
	MiCCB: 'MiCC',
	ZAPPA: 'Zappa',
	UNIFY_PHONE: 'UnifyPhone'
}


export const rbacMode = {
	HIDE: 'hide',
	READONLY: 'readonly',
	UNCHANGEABLE: 'unchangeable'
}

export const applicationNames = {
	OFFICELINK: 'OfficeLink',
	MOMA: 'Mitel Office',
	MONE: 'Mitel One',
	MIVB: 'MiVoice Business'
};

export enum miVBLicenseType {
  NEXT_GEN = 'next_gen',
  LEGACY = 'legacy',
  UCC_EDITION_2 = 'ucc_ed__2',
  UCC_V4_0 = 'ucc_v4_0',
  BUILD_YOUR_OWN = 'build_your_own'
}

export enum licenseUCCEdition2Tier {
  TELEPHONY = 'telephony',
  ENTRY = 'entry',
  PREMIER = 'premier',
  ELITE_CX = 'elite_cx'
};

export enum licenseUCCV40Tier {
  BASIC = 'basic',
  ENTRY = 'entry',
  STANDARD = 'standard',
  PREMIUM = 'premium',
  HOTDESK_SIP_SOFTPHONE = 'hotdesk_sip_softphone'
};

export enum asyncJobStatus {
  QUEUED = 'queued',
  IN_PROGRESS = 'in-progress',
  COMPLETE = 'complete',
  FAILED = 'failed'
}

export enum asyncJobProcessingStatus {
  START = 'start',
  IN_PROGRESS = 'inProgress',
}

export enum asyncJobDataType {
  SUCCESS = 'success',
  DANGER = 'danger',
  IN_PROGRESS = 'in-progress'
}

export enum asyncJobHttpMethod {
	GET = 'GET',
	PUT = 'PUT',
	POST = 'POST',
	DELETE = 'DELETE'
};

export enum asyncJobOwner {
  MIVB = 'mivb',
  MICCB = 'miccb',
  USER_TEMPLATES = 'user-templates',
  ZAPPA_PHONE = 'zappa-phone',
  UNIFY_PHONE = 'unify-phone'
}

export enum alertUpdateTypes {
  CLOSE = 'close',
  LINK = 'link'
}

export enum WorkerState {
  RUNNING = 'Running',
	BOOKMARKED = 'Bookmarked',
  STOPPED = 'Stopped',
};

export enum HttpResponseStatusCode {
  SUCCESSFUL_OK = 200,
  SUCCESSFUL_CREATED = 201,
  SUCCESSFUL_NO_CONTENT = 204
};

export const MiCCBMinimumVersionForUsersIntegration = '10.1.0.0';

export const TemplateBadges = {
	LEARNED: { label: "users_right_panel.quickAdd.badge.learned", color: 'blue' },
	CUSTOMIZED: { label: "users_right_panel.quickAdd.badge.customized", color: 'green' },
	MITEL_DEFAULT: { label: "users_right_panel.quickAdd.badge.mitel_default", color: 'turquoise' },
}

export enum miccbUserStatus {
  UNKNOWN = "unknown",
  USER_UNDEFINED = 'userUndefined',
  USER_DEFINED_FULLACCESS = 'userDefinedFullAccess',
  USER_DEFINED_READONLY = 'userDefinedReadOnly',
  LINK_DOWN = 'linkDown'
};

//GWP places one of these strings in the account's product tags during onboarding
export const gwpOnboardingPbxTags = ['MiVoice Office 250', 'MiVoice Office 400', 'MiVoice Business', 'MiVoice Connect', 'MX-ONE', 'MiVoice 5000'];

export enum ApplicationType {
  MIVOICE_5000 = 'mivoice-5000',
  MIVOICE_BUSINESS = 'mivoice-business',
  MITEL_BORDER_GATEWAY = 'mitel-border-gateway',
  OPEN_SCAPE_VOICE = 'os-voice',
  OPEN_SCAPE_4K = 'os4k'
};

export enum PBXSettingsType {
  MIVOICE_5000 = 'mivo5000',
  OPEN_SCAPE_VOICE = 'osv',
  OPEN_SCAPE_4K = 'os4k',
  MIVOICE_BUSINESS = 'mivb',
}

export enum ComponentType {
  MIVOICE_5000 = 'mivoice-5000',
  MIVOICE_BUSINESS = 'mivoice-business',
  MITEL_BORDER_GATEWAY = 'mitel-border-gateway',
  OPEN_SCAPE_VOICE = 'os-voice',
  OPEN_SCAPE_4K_RMX = 'os4k-rmx',
  OPEN_SCAPE_4K_CSTA = 'os4k-csta'
};

export enum CellType {
  STRING = 'string',
  JSON = 'json'
};

export enum SWAStatus {
  UNKNOWN = 'unknown', // unknown date, no SWA status
  GOOD = 'good',
  EXPIRING_SOON = 'expiring-soon',
  EXPIRED = 'expired',
  SUBSCRIPTION_ACTIVE = 'subscription-active', //subscription based, monthly
  SUBSCRIPTION_INACTIVE = 'subscription-inactive' //subscription based, monthly
};

export enum PortalType {
  NOT_FOUND  = 'not_found',
  ADMIN_PORTAL = 'admin_portal',
  GATEWAY = 'gateway'
};

export enum EventHistoryFilterRequirements {
	MIVB_CAP = 'mivb-cap',
	ZAPPA = 'zappa'
};